export function lionAnimation() {
    const canvasHolder = $(".lion-section .canvas-box");
    const animateSection = document.getElementById("lion-animation-holder");
    const canvas = document.getElementById("lion-animation");
    const context = canvas.getContext("2d");
    if (document.body.classList.contains("no-touch")) {
        canvas.width = 1458;
        canvas.height = 820;

        const currentFrame = index => (`https://verifiedworks-dev.bigdropinc.net/wp-content/themes/bigdrop-theme/dist/images/lion-animations/lion${index.toString().padStart(1)}.jpg`);
        const frameCount = 80;
        const images = [];

        const preloadImages = () => {
            for (let i = 1; i < frameCount; i++) {
                images[i] = new Image();
                images[i].src = currentFrame(i);
            }
        };
        preloadImages();

        const img = new Image();
        img.src = currentFrame(1);
        img.onload = function () {
            context.drawImage(img, 0, 0);
        };
        window.addEventListener("scroll", () => {
            const scrollTop = window.scrollY;
            const sectionOffset = animateSection.offsetTop;
            const maxScrollTop = animateSection.clientHeight;
            if (scrollTop > sectionOffset && scrollTop < sectionOffset + maxScrollTop - 40 && document.body.classList.contains("no-touch")) {
                const scrollFraction = (scrollTop - sectionOffset) / maxScrollTop;
                const scrollTranslate = ((scrollTop - sectionOffset) / (maxScrollTop / 4)) * 100;
                const frameIndex = Math.min(
                    frameCount - 1,
                    Math.floor(scrollFraction * frameCount)
                );
                canvasHolder.css("margin-left", scrollTranslate);

                requestAnimationFrame(() => context.drawImage(images[frameIndex + 1], 0, 0));
            }
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/lionAnimation.js